export default "__VITE_ASSET__DoRosK2Q__"